import { resolveColor } from '../../../../../../colors';

const PentagonLegend = ({ plots, rollingAverage, legendRef }) => (
  <div
    className="duval-legend"
    ref={legendRef}
  >
    {plots &&
      plots.map((plot, index) => (
        <div
          key={index}
          className="duval-legend-item"
        >
          <svg
            width="10"
            height="10"
            style={{ marginRight: '0.5rem' }}
          >
            <rect
              width="10"
              height="10"
              fill={resolveColor(plot.color)}
            />
          </svg>
          {plot.label}
        </div>
      ))}
    {rollingAverage?.show &&
      plots?.map((plot, index) => (
        <div
          key={index}
          className="duval-legend-item"
        >
          <svg
            width="10"
            height="10"
            style={{ marginRight: '0.5rem' }}
          >
            <rect
              width="10"
              height="10"
              fill={resolveColor(plot.rollingAverageColor)}
            />
          </svg>
          {plot.label} rolling average {`(${rollingAverage.decay})`}
        </div>
      ))}
  </div>
);

export default PentagonLegend;
